import React, { Component } from 'react';
import platform from "Pub/js/platform";
const { NCDropdown } = platform.base;
import ajax from 'Pub/js/ajax';
import SearchSelect from './SearchSelect';
import HistoryPanel from './HistoryPanel';
import ResultPanel from './resultPanel';
import { langCheck } from "Pub/js/utils";
import { findDOMNode } from 'react-dom';
import pubSubActions from "Pub/js/pubSubActions";
const { PubSub } = platform;
import noviceGuideAppsearch from "Assets/images/noviceGuide/novice-guide-appsearch.gif";

class SearchInput extends Component {
    constructor(props) {
        super(props);
        this.loadSearchData = this.debounce(this.loadSearchData, 500);
        this.state = {
            dropDownValue: { key: 'bd_apply', label: langCheck("0000PUB-000537"), /* 国际化处理： 应用*/
            }, //存储选中的下拉框的值，默认搜索全部
            selects: [], //存储下拉框默认数据
            value: '', //input值
            isResultPanel:'', //判断显示历史面板还是搜索结果面板,有值是搜索结果面板，无值是历史面板，正常情况应等于value
            menuData: [], //应用菜单数据
            dataInfo: {
                iniBasicData: {}, //其他查询数据(未处理的)
                basicData: [], //其他查询数据(处理后的)
            },
            cacheKeyword: '', //缓存的关键词
            cacheKey: 'all', //缓存的selectKey
            visible: false, //控制面板显隐
            isFocus: false, //input是否聚焦的标志
            menuLoad: false, //应用菜单搜索等待标志
            basicLoad: false, //其他档案等待标志
            resultFocus: 0, //结果面板焦点位置
            inputWidth: '', //搜索select+input的总宽度
        };
    }

    componentDidMount() {
        //唤起搜索监听
        window.addEventListener('keydown', this.handleKeyDown);
        //iframe 监听
        this.subscribeToken = PubSub.subscribe(pubSubActions.global.onIframeKeydown, (key, event) => {
            this.handleKeyDown(event);
        });
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
        PubSub.unsubscribe(this.subscribeToken); //移除订阅
    }

    // Alt + K 快捷鍵
    handleKeyDown = e => {
        let { isFocus } = this.state;
        if (e.altKey && e.keyCode === 75) {
            e.preventDefault();
            if (isFocus) {
                this.refInput.blur();
            } else {
                this.refInput.focus();
            }
        }
    }

    render() {
        const { ispreview } = this.props;
        let { value, visible, isFocus, menuData, selects, dataInfo, menuLoad, basicLoad, resultFocus, dropDownValue, inputWidth, isResultPanel } = this.state;
        let { label, key } = dropDownValue;
        let { basicData, iniBasicData } = dataInfo;
        const dataIntro = `<img src=${noviceGuideAppsearch} alt="" class='novice-guide-appsearch' />
                    <p>${langCheck("0000PUB-000298")}</p>
                <div class='span-box'>
                    <span>${langCheck("0000PUB-000299")}</span>
                </div>
                <i class='iconfont icon-guanbi2 guide-close' onclick="handleWorkbenchIntro('close')"></i>
                `;
        return <NCDropdown
            getPopupContainer={() => this.searchWrapperRef}
            overlayClassName="panel-show"
            overlay={isResultPanel ?
                <ResultPanel
                    data={{ menuData, basicData, iniBasicData }}
                    keyword={value}
                    type={dropDownValue}
                    load={{ menuLoad, basicLoad }} //骨架屏
                    refInput={this.refInput} //监听上下箭头
                    curFocus={resultFocus}
                    onFocusChange={curFocus => { console.log('curFoucs', curFocus), this.setState({ resultFocus: curFocus }); }}
                    onHidden={() => this.refInput.blur()}
                    updateCollect={this.handleResultUpdate}
                />
                :
                <HistoryPanel
                    focus={isFocus}
                    onHidden={() => this.refInput.blur()}
                    onHistoryClick={title => this.handleChange(title)}
                    type={dropDownValue}
                    refInput={this.refInput}
                />
            }
            visible={visible}
            animation="slide-up"
            overlayStyle={{ width: `${inputWidth}px` }}
        >
            <div
                ref={ref => this.searchWrapperRef = ref}
                className={"search-wrapper"}
                {...(ispreview ? {} : {
                    "data-step": "3",
                    "data-intro": dataIntro
                })}
            >
                <SearchSelect
                    selects={selects}
                    displayInfo={dropDownValue}
                    onSelect={dropDownValue => {
                        this.setState({ dropDownValue }, () => {
                            findDOMNode(this).querySelector('input').focus();
                        });
                    }}
                    onSelectsSet={selects => {
                        this.setState({ selects });
                    }
                    }
                />
                <div
                    fieldid="global-search"
                    className="input-right"
                >
                    <i className='icon iconfont icon-sousuo1 icon-search'></i>
                    <input
                        className={`search-input paddingLeft ${isFocus ? 'lightColor' : ""}`}
                        value={value}
                        placeholder={key === "all" ?
                            isFocus ?
                                langCheck("0000PUB-000538") /* 国际化处理： alt+k取消搜索*/
                                :
                                langCheck("0000PUB-000539") /* 国际化处理： alt+k唤起搜索*/
                            :
                            `${langCheck("0000PUB-000540")}${label}` /* 国际化处理： 请输入*/
                        }
                        ref={input => { this.refInput = input; }}
                        onChange={e => this.handleChange(e.target.value)}
                        onFocus={e => this.handleFocus(e)}
                        onBlur={this.handleBlur}
                    />
                    {value &&
                        <i className="icon iconfont icon-qingkong input-suffix"
                            onClick={this.handleClear}
                            onMouseDown={e => e.preventDefault()}
                        />
                    }
                </div>
            </div>
        </NCDropdown>;
    }

    // 获取resultPanel的值
    loadSearchData = keyword => {
        let { cacheKeyword, cacheKey, menuData = [], dataInfo, dropDownValue, selects } = this.state;
        let { basicData } = dataInfo;
        let { key } = dropDownValue;
        //处理空格 不走接口
        // (/[\w]/.test(keyword) && /^[\u4e00-\u9fa5]/.test(keyword))
        if (!keyword.trim() ) {
            this.setState({
                menuLoad: false,
                basicLoad: false,
                cacheKeyword: keyword,
                cacheKey: key,
                menuData: [],
                dataInfo: {
                    iniBasicData: {}, //其他查询数据(未处理的)
                    basicData: [], //其他查询数据(处理后的)
                },
            });
            return;
        }
        // 请求之前判断是否取缓存数据,   
        if (keyword === cacheKeyword && key === cacheKey) {
            this.setState({
                resultFocus: 0,
                menuLoad: false,
                basicLoad: false,
            });
            if (menuData.length || basicData.length) {
                this.setState({ resultFocus: 2, //结果面板焦点设置为第一个选项
                });
            }
            return;
        }
        //  清空所有缓存
        this.setState({
            menuData: [],
            dataInfo: {
                iniBasicData: {}, //其他查询数据(未处理的)
                basicData: [], //其他查询数据(处理后的)
            },
        });
        // 1.搜索非应用的其他类型 2.搜索关键词和当前value做对比，确保返回的结果是当前关键词返回的。 
        if (key !== "bd_apply" ) {
            ajax({
                url: "/nccloud/uapss/gsc/queryall.do",
                data: {
                    source_groups: [key],
                    search_string: keyword.trim(),
                    page_size: 5,
                },
                success: res => {
                    // console.log("基本档案查询完成", res.data.data)
                    if (res && res.data && this.state.value === keyword) {
                        //数据处理
                        let cacheData = JSON.parse(JSON.stringify(res.data.data));
                        let data = res.data.data;
                        let index = 2; //index是标题分类下的行信息的顺序标识，便于curFocus视觉定位
                        let newSelects = selects.slice(2, selects.length);
                        let lastTotalIndex = 0;
                        //给标题添加index顺序标识，便于curFocus视觉定位
                        let getTitleIndex = index => {
                            let curTotalIndex = ((data[newSelects[index].id] || {}).rows || {}).length || 0;
                            if (curTotalIndex == 0) {
                                return;
                            }
                            let totalIndex = 0;
                            totalIndex = lastTotalIndex + 1;
                            lastTotalIndex = curTotalIndex + lastTotalIndex + 1;
                            return totalIndex;
                        };
                        let results = newSelects.map((item, selectIndex) => {
                            let key = item.id;
                            let titleIndex = getTitleIndex(selectIndex);
                            let rows = (data[key] || {}).rows || [];
                            if (rows.length) {
                                //给每个分类添加index标识，用于↑↓事件
                                rows.forEach((item, i) => {
                                    item.index = index; //↑↓事件
                                    cacheData[key].rows[i].index = index; //渲染对比curFocus用
                                    if (i !== rows.length - 1) {
                                        index++;
                                    } else {
                                        index = index + 2;
                                    }
                                });
                                return { ...data[key], type: key, titleIndex };
                            }
                        }).filter(n => n);
                        //设置结果面板焦点
                        let content = {
                            dataInfo: {
                                iniBasicData: cacheData, //其他查询数据(未处理的)
                                basicData: results, //其他查询数据(处理后的)
                            },
                            cacheKeyword: keyword,
                            cacheKey: key,
                            basicLoad: false,
                        };

                        if (results.length > 0) {
                            this.setState({
                                ...content,
                                resultFocus: 2,
                            });
                        } else {
                            this.setState(content);
                        }
                    }
                },
                error: () => {
                    console.log('请求失败');
                    this.setState({ basicLoad: false });
                },
            });
        }

        // 根据分类和keyword查询应用菜单
        if ((key === "all" || key == "bd_apply")) {
            ajax({
                url: `/nccloud/platform/appregister/searchmenuitem.do`,
                data: {
                    search_content: keyword.trim(),
                    apptype: "1",
                },
                success: res => {
                    const { data, success } = res.data;
                    if (
                        success &&
                        data &&
                        data.children && 
                        this.state.value === keyword
                    ) {
                        let menuData = data.children;
                        //结果面板焦点
                        if (menuData.length > 0) {
                            this.setState({
                                menuData,
                                cacheKeyword: keyword,
                                cacheKey: key,
                                menuLoad: false,
                                resultFocus: 2,
                            });
                        } else {
                            this.setState({
                                menuData,
                                cacheKeyword: keyword,
                                cacheKey: key,
                                menuLoad: false,
                            });
                        }
                    }
                },
                error: () => {
                    console.log('请求失败');
                    this.setState({ menuLoad: false });
                },
            });
        }
    }

    handleFocus = e => {
        let { value } = this.state;
        let target = e.target;
        // 选中文字
        target.setSelectionRange(0, value.length);
        //打开面板 
        this.handlePanelVisible(true);
        //input是否聚焦标志位
        this.setState({
            isFocus: true,
            menuLoad: true,
            basicLoad: true,
            resultFocus: 0,
            inputWidth: (document.querySelector('.search-wrapper') || {}).offsetWidth,
        });
        // 切换分类时的数据清空处理
        this.handleKeyChange();
        // 请求后端
        this.loadSearchData(value);
    }

    handleBlur = () => {
        //关闭面板
        this.handlePanelVisible(false);
        //设置失焦标志位
        this.setState({ isFocus: false });
    }

    handleChange = value => {
        if(value==="") { //主要为了解决NCC-388739,搜索结果面板和历史面板切换要有缓冲
            setTimeout(()=>{
                if(!this.state.value) {
                    this.setState({ isResultPanel:"" });
                }
            }, 500);
            this.setState({ value:value, resultFocus:0 }, ()=>{
                this.handleKeyChange();
            }); 
        } else {
            this.setState({
                value,
                menuLoad: true,
                basicLoad: true,
                resultFocus: 0,
                isResultPanel:value,
            }, () => {
                // 切换分类时的数据清空处理
                this.handleKeyChange();
                // 触发搜索 
                this.loadSearchData(value);
            });
        }
       
    }
    handleKeyChange = () => {
        let { key } = this.state.dropDownValue;
        if (key === "bd_apply") { //如果是应用，清空其他档案信息
            this.setState({
                dataInfo: {
                    iniBasicData: [],
                    basicData: [],
                },
                basicLoad: false,
            });
        } else if (key !== "bd_apply" && key !== "all") { //如果是其他档案，清空应用菜单信息
            this.setState({
                menuData: [],
                menuLoad: false,
            });
        } else {
            return;
        }
    }

    debounce = (fn, delay) => {
        let timer;
        return function (rest) {
            if (timer) {clearTimeout(timer);}
            timer = setTimeout(() => {
                fn(rest);
            }, delay);
        };
    }

    handleClear = () => {
        //清空value
        this.setState({ value: '', isResultPanel:'' }, () => {
            this.refInput.focus();
        });
    }

    //面板开启关闭
    handlePanelVisible = visible => {
        this.setState({ visible: visible });
    }
    // 更新收藏图标回调函数
    handleResultUpdate = resultData => {
        this.setState({ menuData: resultData, //改变menuData中的is_collect字段更新界面收藏图标
        });
    }
}

export default SearchInput;

